import React from 'react';
import LegalLayout from './LegalLayout';
import { useAuth } from '../../App';

const Privacy = () => {
  const { language } = useAuth();
  const isDe = language === 'de';

  return (
    <LegalLayout
      title={isDe ? 'Datenschutzerklärung' : 'Privacy Policy'}
      updated={isDe ? '12. Februar 2026' : 'February 12, 2026'}
      testId="privacy-page"
    >
      {isDe ? (
        <>
          <p>
            Padelarena Wädenswil (&bdquo;wir&ldquo;, &bdquo;uns&ldquo;) nimmt den Schutz deiner
            Personendaten ernst. Diese Datenschutzerklärung informiert dich
            gemäss dem revidierten Schweizer Datenschutzgesetz (revDSG) und —
            soweit anwendbar — der EU-DSGVO über die Verarbeitung deiner Daten.
          </p>

          <h2>1. Verantwortliche Stelle</h2>
          <p>
            <strong>Padelarena Wädenswil</strong><br />
            E-Mail: <a href="mailto:info@padelarena.ch">info@padelarena.ch</a>
          </p>

          <h2>2. Welche Daten wir verarbeiten</h2>
          <ul>
            <li><strong>Konto-Daten</strong>: Name, E-Mail, Telefonnummer, Passwort (bcrypt-gehasht), Spielerlevel.</li>
            <li><strong>Buchungsdaten</strong>: reservierte Plätze/Slots, Zeitpunkt, Anzahl Spieler, Preisberechnung.</li>
            <li><strong>Zahlungsdaten</strong>: Zahlungsart (Bar/Karte/TWINT/Abo/Gutschein), Betrag, Transaktions-ID. Kartendaten werden ausschliesslich vom Zahlungsdienstleister (Datatrans AG, CH) verarbeitet — wir sehen und speichern keine Kreditkartennummern.</li>
            <li><strong>Kommunikation</strong>: E-Mails, die du an uns richtest, sowie transaktionale System-E-Mails (Buchungsbestätigungen, Warteliste-Benachrichtigungen).</li>
            <li><strong>Rating-Daten</strong>: Match-Ergebnisse, Padlr-Rating-Historie, Level-Änderungen aus Mixins/Turnieren.</li>
            <li><strong>Technische Daten</strong>: IP-Adresse (temporär für Sicherheit), Browser-Typ, Zeitstempel der Zugriffe.</li>
          </ul>

          <h2>3. Zweck der Verarbeitung</h2>
          <ul>
            <li>Verwaltung deines Kundenkontos und deiner Buchungen</li>
            <li>Abwicklung von Zahlungen und Rückerstattungen</li>
            <li>Kommunikation über Buchungen, Änderungen und Warteliste</li>
            <li>Betrieb des Bewertungs- und Matching-Systems (Padlr Rating)</li>
            <li>Erfüllung gesetzlicher Aufbewahrungspflichten (z.B. Buchhaltung)</li>
            <li>Verbesserung des Angebots (aggregierte, nicht-personenbezogene Statistiken)</li>
          </ul>

          <h2>4. Rechtsgrundlage</h2>
          <p>
            Wir verarbeiten deine Daten auf Grundlage deiner Einwilligung (Art. 6
            revDSG), zur Erfüllung des Nutzungsvertrags sowie zur Erfüllung
            gesetzlicher Pflichten.
          </p>

          <h2>5. Weitergabe an Dritte</h2>
          <p>
            Wir geben deine Daten <strong>nicht</strong> an Dritte weiter, ausser
            an folgende sorgfältig ausgewählte Auftragsverarbeiter:
          </p>
          <ul>
            <li><strong>Datatrans AG</strong> (Zürich, CH) — Zahlungsabwicklung (TWINT, Karten, Apple/Google Pay)</li>
            <li><strong>Resend Inc.</strong> — Versand transaktionaler E-Mails</li>
            <li><strong>MongoDB / Cloud-Hosting</strong> — verschlüsselte Datenspeicherung in europäischen Rechenzentren</li>
          </ul>
          <p>
            Alle Auftragsverarbeiter sind vertraglich zur Einhaltung des
            Datenschutzes verpflichtet.
          </p>

          <h2>6. Speicherdauer</h2>
          <p>
            Konto-Daten werden gespeichert, solange dein Konto aktiv ist.
            Buchungs- und Zahlungsdaten werden aus buchhalterischen Gründen
            10 Jahre aufbewahrt. Nach Löschung deines Kontos werden alle nicht
            gesetzlich aufbewahrungspflichtigen Daten innerhalb von 30 Tagen entfernt.
          </p>

          <h2>7. Deine Rechte</h2>
          <p>Du hast jederzeit das Recht auf:</p>
          <ul>
            <li><strong>Auskunft</strong> über die zu deiner Person gespeicherten Daten (Art. 25 revDSG)</li>
            <li><strong>Berichtigung</strong> unrichtiger Daten (Art. 32 revDSG)</li>
            <li><strong>Löschung</strong> deines Kontos und der zugehörigen Daten</li>
            <li><strong>Datenübertragbarkeit</strong> (Export deiner Daten in maschinenlesbarer Form)</li>
            <li><strong>Widerruf</strong> der Einwilligung mit Wirkung für die Zukunft</li>
          </ul>
          <p>
            Alle Anfragen richtest du bitte an{' '}
            <a href="mailto:info@padelarena.ch">info@padelarena.ch</a>. Wir
            antworten innert 30 Tagen.
          </p>

          <h2>8. Datensicherheit</h2>
          <p>
            Wir setzen technische und organisatorische Massnahmen ein, um deine
            Daten vor unbefugtem Zugriff, Verlust oder Missbrauch zu schützen:
            HTTPS/TLS-Verschlüsselung, bcrypt-Passwort-Hashing, rollenbasierte
            Zugriffskontrolle, HttpOnly-Cookies, regelmässige Backups.
          </p>

          <h2>9. Cookies</h2>
          <p>
            Wir verwenden ausschliesslich <strong>technisch notwendige Cookies</strong>{' '}
            (Session-Cookies für die Anmeldung). Es werden <strong>keine
            Tracking-, Werbe- oder Analyse-Cookies</strong> Dritter gesetzt.
          </p>

          <h2>10. Push-Benachrichtigungen</h2>
          <p>
            Falls du Push-Benachrichtigungen aktivierst (Web-Push für Warteliste
            &amp; Mixin-Updates), speichern wir deinen Browser-Subscription-Token.
            Du kannst die Benachrichtigungen jederzeit in deinem Browser oder in
            der App wieder deaktivieren.
          </p>

          <h2>11. Änderungen</h2>
          <p>
            Wir behalten uns Änderungen dieser Datenschutzerklärung vor. Die
            jeweils aktuelle Fassung ist unter{' '}
            <a href="/privacy">bookpadelarena.ch/privacy</a> abrufbar.
          </p>

          <h2>Kontakt</h2>
          <p>
            Bei Fragen zum Datenschutz erreichst du uns unter{' '}
            <a href="mailto:info@padelarena.ch">info@padelarena.ch</a>.
          </p>
        </>
      ) : (
        // ============ ENGLISH ============
        <>
          <p>
            Padelarena Wädenswil (&ldquo;we&rdquo;, &ldquo;us&rdquo;) takes the protection of your
            personal data seriously. This privacy policy informs you — in
            accordance with the revised Swiss Data Protection Act (revFADP) and,
            where applicable, the EU GDPR — about how we process your data.
          </p>

          <h2>1. Data controller</h2>
          <p>
            <strong>Padelarena Wädenswil</strong><br />
            Email: <a href="mailto:info@padelarena.ch">info@padelarena.ch</a>
          </p>

          <h2>2. Which data we process</h2>
          <ul>
            <li><strong>Account data</strong>: name, email, phone, password (bcrypt-hashed), player level.</li>
            <li><strong>Booking data</strong>: courts/slots reserved, time, number of players, price calculation.</li>
            <li><strong>Payment data</strong>: payment method (cash/card/TWINT/subscription/voucher), amount, transaction ID. Card details are processed exclusively by the payment provider (Datatrans AG, CH) — we never see or store card numbers.</li>
            <li><strong>Communication</strong>: emails you send us and transactional system emails (booking confirmations, waitlist notifications).</li>
            <li><strong>Rating data</strong>: match results, Padlr rating history, level changes from mixins/tournaments.</li>
            <li><strong>Technical data</strong>: IP address (temporary, for security), browser type, access timestamps.</li>
          </ul>

          <h2>3. Purpose</h2>
          <ul>
            <li>Managing your account and bookings</li>
            <li>Processing payments and refunds</li>
            <li>Communication about bookings, changes and waitlist</li>
            <li>Operating the rating and matching system (Padlr Rating)</li>
            <li>Fulfilling legal retention obligations (e.g. accounting)</li>
            <li>Improving our service (aggregated, non-personal statistics)</li>
          </ul>

          <h2>4. Legal basis</h2>
          <p>
            We process your data based on your consent (Art. 6 revFADP), for the
            performance of the contract, and to fulfil legal obligations.
          </p>

          <h2>5. Third-party disclosure</h2>
          <p>
            We do <strong>not</strong> share your data with third parties, except
            with the following carefully selected processors:
          </p>
          <ul>
            <li><strong>Datatrans AG</strong> (Zürich, CH) — payment processing (TWINT, cards, Apple/Google Pay)</li>
            <li><strong>Resend Inc.</strong> — transactional email delivery</li>
            <li><strong>MongoDB / cloud hosting</strong> — encrypted data storage in European data centres</li>
          </ul>
          <p>All processors are contractually bound to data protection.</p>

          <h2>6. Retention</h2>
          <p>
            Account data is stored as long as your account is active.
            Booking and payment data is retained for 10 years for accounting
            purposes. After account deletion, any data not subject to legal
            retention is removed within 30 days.
          </p>

          <h2>7. Your rights</h2>
          <p>You have the right, at any time, to:</p>
          <ul>
            <li><strong>Access</strong> the data we store about you (Art. 25 revFADP)</li>
            <li><strong>Correction</strong> of inaccurate data (Art. 32 revFADP)</li>
            <li><strong>Deletion</strong> of your account and associated data</li>
            <li><strong>Data portability</strong> (export in machine-readable format)</li>
            <li><strong>Withdrawal</strong> of consent with future effect</li>
          </ul>
          <p>
            Please direct all requests to{' '}
            <a href="mailto:info@padelarena.ch">info@padelarena.ch</a>. We
            respond within 30 days.
          </p>

          <h2>8. Security</h2>
          <p>
            We employ technical and organisational measures to protect your
            data against unauthorised access, loss or misuse: HTTPS/TLS
            encryption, bcrypt password hashing, role-based access control,
            HttpOnly cookies, regular backups.
          </p>

          <h2>9. Cookies</h2>
          <p>
            We use only <strong>strictly necessary cookies</strong> (session
            cookies for authentication). We do <strong>not</strong> set any
            third-party tracking, advertising, or analytics cookies.
          </p>

          <h2>10. Push notifications</h2>
          <p>
            If you enable push notifications (web-push for waitlist &amp; mixin
            updates), we store your browser subscription token. You can disable
            notifications at any time via your browser or the app.
          </p>

          <h2>11. Changes</h2>
          <p>
            We reserve the right to change this policy. The current version is
            always available at{' '}
            <a href="/privacy">bookpadelarena.ch/privacy</a>.
          </p>

          <h2>Contact</h2>
          <p>
            For privacy questions reach us at{' '}
            <a href="mailto:info@padelarena.ch">info@padelarena.ch</a>.
          </p>
        </>
      )}
    </LegalLayout>
  );
};

export default Privacy;
